import * as Types from '../../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SaveConfigMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['String']['input']>;
  config: Types.Scalars['JSON']['input'];
  environmentId: Types.Scalars['String']['input'];
  name?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type SaveConfigMutation = { __typename?: 'Mutation', saveActionFlowConfiguration?: { __typename?: 'ActionFlowConfigurationPayload', actionFlowConfig?: { __typename?: 'ActionFlowConfig', id: string, hasDirtyDraft?: boolean | null, status: Types.ActionFlowConfigStatus, hasPublishedVersions?: boolean | null, currentVersion?: { __typename?: 'ActionFlowConfigVersion', nodeId: string, status: Types.ActionFlowVersionStatus, updated?: string | null } | null, versions: { __typename?: 'ActionFlowConfigVersionsConnection', nodes: Array<{ __typename?: 'ActionFlowConfigVersion', nodeId: string }> } } | null } | null };


export const SaveConfigDocument = gql`
    mutation SaveConfig($id: String, $config: JSON!, $environmentId: String!, $name: String) {
  saveActionFlowConfiguration(
    input: {id: $id, config: $config, environmentId: $environmentId, name: $name}
  ) {
    actionFlowConfig {
      id
      hasDirtyDraft
      status
      hasPublishedVersions
      currentVersion {
        nodeId
        status
        updated
      }
      versions: actionFlowConfigVersionsByEnvironmentIdAndFlowConfigId {
        nodes {
          nodeId
        }
      }
    }
  }
}
    `;

/**
 * __useSaveConfigMutation__
 *
 * To run a mutation, you first call `useSaveConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveConfigMutation, { data, loading, error }] = useSaveConfigMutation({
 *   variables: {
 *      id: // value for 'id'
 *      config: // value for 'config'
 *      environmentId: // value for 'environmentId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSaveConfigMutation(baseOptions?: Apollo.MutationHookOptions<SaveConfigMutation, SaveConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveConfigMutation, SaveConfigMutationVariables>(SaveConfigDocument, options);
      }
export type SaveConfigMutationHookResult = ReturnType<typeof useSaveConfigMutation>;
export type SaveConfigMutationResult = Apollo.MutationResult<SaveConfigMutation>;
export type SaveConfigMutationOptions = Apollo.BaseMutationOptions<SaveConfigMutation, SaveConfigMutationVariables>;